// File: frontend/src/utils/historyFormatters.js
// Version: 1.0 (2026-10-16)
// Description: Форматирование заголовков событий и имён лидов для ленты истории.
//              Для русского языка (Fitenko) оставляет точные серверные формулировки.
//              Для английского переводит через словарь i18n и код события.

export const formatEventTitle = (title, eventType, t, lang) => {
    if (lang === 'ru' || !title) return title || '—';
    if (title === 'Обращение принято' || (eventType === 'lead_created' && title === 'Обращение принято')) {
        return (t && t('firm_today.history.inquiry_received')) || 'Inquiry received';
    }
    if (title.startsWith('Обращение принято:')) {
        const suffix = title.slice('Обращение принято:'.length);
        const prefix = (t && t('firm_today.history.inquiry_received')) || 'Inquiry received';
        return `${prefix}:${suffix}`;
    }
    if (title === 'Звонок') return (t && t('firm_today.history.call')) || 'Call';
    if (title === 'СМС') return (t && t('firm_today.history.sms')) || 'SMS';
    if (title === 'Письмо') return (t && t('firm_today.history.email')) || 'Email';
    if (title.startsWith('Письмо:')) {
        const suffix = title.slice('Письмо:'.length);
        const prefix = (t && t('firm_today.history.email')) || 'Email';
        return `${prefix}:${suffix}`;
    }
    if (title === 'Загружен документ') return (t && t('firm_today.history.document_uploaded')) || 'Document uploaded';
    if (title.startsWith('Загружен документ:')) {
        const suffix = title.slice('Загружен документ:'.length);
        const prefix = (t && t('firm_today.history.document_uploaded')) || 'Document uploaded';
        return `${prefix}:${suffix}`;
    }

    // Cases & Tasks (legacy_crud.py & cases.py):
    if (title === 'Дело создано' || eventType === 'case_created') {
        if (title.startsWith('Дело создано:')) {
            const suffix = title.slice('Дело создано:'.length);
            return `Case created:${suffix}`;
        }
        if (title === 'Дело создано') return 'Case created';
    }
    if (title.startsWith('Дело создано:')) {
        return `Case created:${title.slice('Дело создано:'.length)}`;
    }

    if (title.startsWith('Создана задача:')) {
        return `Task created:${title.slice('Создана задача:'.length)}`;
    }
    if (title === 'Создана задача') return 'Task created';

    if (title.startsWith('Завершена задача:')) {
        return `Task completed:${title.slice('Завершена задача:'.length)}`;
    }
    if (title === 'Завершена задача') return 'Task completed';

    if (title.startsWith('Статус дела:')) {
        return `Case status:${title.slice('Статус дела:'.length)}`;
    }

    // Decisions & Deadlines (email_triage.py & razryady.py & case_deadlines.py):
    if (title === 'Черновик одобрен и отправлен') return 'Draft approved and sent';
    if (title === 'Срок дела изменён') return 'Case deadline updated';
    if (title === 'Срок поставлен') return 'Deadline set';
    if (title === 'Срок признан неизвестным') return 'Deadline marked unknown';
    if (title === 'Срок снят') return 'Deadline removed';
    if (title === 'Поставлен в очередь') return 'Queued';
    if (title === 'Вопрос') return 'Question';
    if (title === 'Назначение команды' || title === 'Назначение') return 'Team assignment';

    return title;
};

export const formatLeadName = (imya, t, lang) => {
    if (!imya) return imya;
    if (lang === 'ru') {
        if (imya === 'No name') {
            return (t && t('firm_today.history.unnamed')) || 'Без имени';
        }
        if (imya.startsWith('No name')) {
            const unnamedLabel = (t && t('firm_today.history.unnamed')) || 'Без имени';
            return imya.replace(/^No name/, unnamedLabel);
        }
        return imya;
    }
    if (imya === 'Без имени') {
        return (t && t('firm_today.history.unnamed')) || 'No name';
    }
    if (imya.startsWith('Без имени')) {
        const unnamedLabel = (t && t('firm_today.history.unnamed')) || 'No name';
        return imya.replace(/^Без имени/, unnamedLabel);
    }
    return imya;
};
